import { useState, ReactNode } from 'react';

interface TabItem {
    id: string;
    label: string;
    content: ReactNode;
    isNoPadding?: boolean;
    icon?: string;
}

interface TabsProps {
    tabs: TabItem[];
    defaultActiveTab?: string;
    onTabChange?: (tabId: string) => void;
    className?: string;
}

const Tabs = ({
    tabs,
    defaultActiveTab,
    onTabChange,
    className = '',
}: TabsProps) => {
    const [activeTab, setActiveTab] = useState(
        defaultActiveTab || tabs[0]?.id || '',
    );

    const handleTabChange = (tabId: string) => {
        setActiveTab(tabId);
        onTabChange?.(tabId);
    };

    return (
        <div className={`w-100 ${className}`}>
            <nav className="nav tab-style-1 nav-pills mb-3" role="tablist">
                {tabs.map(tab => (
                    <a
                        key={tab.id}
                        className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={e => {
                            e.preventDefault();
                            handleTabChange(tab.id);
                        }}
                        role="tab"
                        aria-selected={activeTab === tab.id}
                        aria-controls={tab.id}
                        href={`#${tab.id}`}
                        style={{ cursor: 'pointer' }}
                    >
                        {tab.icon && <i className={`${tab.icon} me-1`} />}
                        {tab.label}
                    </a>
                ))}
            </nav>

            <div className="tab-content">
                {tabs.map(tab => (
                    <div
                        key={tab.id}
                        id={tab.id}
                        role="tabpanel"
                        className={`tab-pane pt-0 ${tab.isNoPadding ? 'p-0' : ''} border-0 ${activeTab === tab.id ? 'active show' : ''}`}
                    >
                        {tab.content}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Tabs;
